<template>
  <div id="preloader">
    <div class="fake-assets" />
    <div class="fake-options" />
    <div class="fake-viewer" />
  </div>
</template>
<script>
export default {
  name: 'Preloader'
}
</script>
<style scoped>
@keyframes overlay {
  0% { opacity: .6; }
  50% { opacity: 1; }
  100% { opacity: .6; }
}
#preloader{
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 40px 0;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  z-index: 999;
}
.fake-assets{
  -webkit-box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  padding: 20px;
  background-color: #CFDEEC;
  border-radius: 8px;
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  z-index: 999;
  animation: overlay 2s ease infinite;
}
.fake-options {
  -webkit-box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  padding: 20px;
  background-color: #CFDEEC;
  border-radius: 8px;
  margin: 0 0 20px;
  width: 100%;
  position: relative;
  z-index: 999;
  animation: overlay 2s ease infinite;
}
.fake-viewer {
  -webkit-box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  padding: 20px;
  background-color: #CFDEEC;
  border-radius: 8px;
  width: 100%;
  max-width: 620px;
  position: relative;
  z-index: 999;
  animation: overlay 2s ease infinite;
}
@media only screen and (min-width: 992px) {
  #preloader{
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    min-height: 908px;
  }
  .fake-assets{
    margin-bottom: 0;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 140px;
    flex: 0 0 140px;
  }
  .fake-options {
    margin: 0 20px 0;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 400px;
    flex: 0 0 400px;
  }
  .fake-viewer {
    width: calc(100% - 700px);
  }
}
</style>
